import { selectScreeningResults } from '@/redux/selectors/constantsSelectors';
import { useAppSelector } from '@/redux/hooks';
import BoolIcon from './_common/BoolIcon';
import Tooltip from '@mui/material/Tooltip/Tooltip';
import styled from '@emotion/styled';

type ResultDisplayProps = {
    result?: string;
    remarks?: string;
};

const ResultDisplay = ({ result,
remarks
}: ResultDisplayProps) => {
    const screeningResultsLabels = useAppSelector(selectScreeningResults);
    return result ? (
        <StyledTooltip title={remarks || ''} placement="top" arrow pass={result === 'pass' ? 1 : 0}>
            <div>
                <BoolIcon label={(screeningResultsLabels[result || ''] || 'Unknown')} displayUnknown checked={result ? result === 'pass' : undefined} />
            </div>  
        </StyledTooltip>
    ) : (
        <div>-</div>
    );
};

export default ResultDisplay;

const StyledTooltip = styled(Tooltip)<{pass: number}>`
    color: ${({ theme , pass }) => pass ? theme.palette.success.main : theme.palette.error.main};

    svg {
        color: ${({ theme , pass }) => pass ? theme.palette.success.main : theme.palette.error.main};
    }
`